import { render, staticRenderFns } from "./TestRunnerWrapper.vue?vue&type=template&id=07d67986"
import script from "./TestRunnerWrapper.vue?vue&type=script&lang=js"
export * from "./TestRunnerWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports